import React, { useState, useEffect, useContext } from "react";
import Header from "./Header";
// import Header from "../components/dashboard/header";
import Footer from "./Footer";
import errorImg from '../assets/images/error-img.png';
import tmdbApi from "../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import sessionbg from "../assets/images/session-bg.svg"

const Contact = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

    }, []);
const name = localStorage.getItem('name');
const emailid=localStorage.getItem('email');

// console.log(111, name)
    const [formData, setFormData] = useState({
        name: name ? name : '',
        email: emailid ? emailid : '',
      
        messageType: '',
        message: '',
    });

    const [errors, setErrors] = useState({});
    const [email, setEmail] = useState(null)
    const [phone, setPhone] = useState(null)
    const [address, setAddress] = useState(null)
    const [success, setSuccess] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });

        // Reset error message as user types
        setErrors({
            ...errors,
            [e.target.name]: '',
        });
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email is invalid';
        if (!formData.messageType) newErrors.messageType = 'Please select a message type';
        if (!formData.message.trim()) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        try {
            const response = await tmdbApi.contactus({
                "emailid": formData?.email,
                "name": formData?.name,
                "subject": formData?.name,
                "message": formData?.message,
                "msg": formData?.message,
                "messagetype": formData?.messageType
            })
            console.log(1111, response)

            if (response.result === "Email Sent Successfully") {
                setSuccess(true);
                setFormData({ name: '', email: '', messageType: '', message: '' });
                setErrors({});
            } else {
                // alert('Failed to submit form. Please try again.');
            }
        } catch (error) {
            console.error('Submission error:', error);
            alert('Error submitting the form.');
        }
    };

    function onConfirm() {

        setSuccess(false);
        // navigate("/dashboard")
        // navigate("/addquestion/" + dynamicQuizId);
        // window.location.reload()
    };

    const siteInfo = async () => {

        try {
            const response = await tmdbApi.configData();

            setEmail(response?.result[0]?.contactus?.email)
            setAddress(response?.result[0]?.contactus?.address)
            setPhone(response?.result[0]?.contactus?.Phone)

        } catch {
            console.log("site config error")
        }
    };


    useEffect(() => {
        siteInfo()
    }, [])

    return (
        <>
            <Header />

            {/* <section className="about-us-section">
                <div className="container">
                    <h3 className="txt-48">Contact</h3>
                    <p className="txt-16">Precision Diagnostics. Lifelong Learning. Global Impact.</p>
                </div>
            </section> */}


            {/* <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-notfound">
                            <div className="no_data">
                                <img src={errorImg} />
                                <h3>Coming Up</h3>
                                <p>Stay tuned with us!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <SweetAlert show={success}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Email sent successfully"}
                onConfirm={e => onConfirm()}
            >
            </SweetAlert>
            <div className="contact-us-page">
                <section className="about-us-section ">
                    <div className="container">
                        <h3 className="txt-48">CONTACT US</h3>
                        <p className="txt-16">If you would like to learn more about the platform or have other enquiries,<br className="d-none d-md-block" /> here are the different ways we can be contacted.</p>
                    </div>
                </section>
                <div className="learning-hub-section inner-container">
                    <div className="we-are_bg">
                        <img src={sessionbg} alt="DADI Logo" width="1130" />
                    </div>
                    <section className="contact section-bg mt-3">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="info-box mb-4">
                                        <span className="material-symbols-outlined">location_on</span>
                                        <h3>Our Address</h3>
                                        {address && <p className="address">{address}</p>}

                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <div className="info-box mb-4">
                                        <span className="material-symbols-outlined">email</span>
                                        <h3>Our Contact Info</h3>
                                        {email && <p className="address">{email}</p>}
                                        {phone && <p className="address">{phone}</p>}

                                        <p><a></a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-lg-6">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d7601.330897310794!2d83.3023975412785!3d17.713257482921932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s16-11-22%2F4%2C%20Opposite%20APEX%20Hospital%2C%20Coastal%20Battery%20Road%20(Beach%20Down)%2C%20Maharanipeta-530002%20(Opposite%20APEX%20Hospital)!5e0!3m2!1sen!2sin!4v1747051430601!5m2!1sen!2sin"
                                        style={{ border: 0, width: "100%", height: "384px" }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="Google Map"
                                    ></iframe>
                                </div>
                                <div className="col-lg-6">
                                    <div className="info-box mb-4">
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-section">
                                                <div className="row contact-form">
                                                    {/* Name */}
                                                    <div className="col-md-6 form-group">
                                                        <div className="form-floating">
                                                            <input
                                                                type="text"
                                                                name="name"
                                                                disabled={name ? true : false}
                                                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                                                // placeholder="First Name"
                                                                value={formData.name}
                                                                onChange={handleChange}
                                                            />
                                                            <label>Your Name</label>
                                                            {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                                                        </div>
                                                    </div>

                                                    {/* Email */}
                                                    <div className="col-md-6 form-group">
                                                        <div className="form-floating">
                                                            <input
                                                                type="email"
                                                                name="email"
                                                                disabled={emailid ? true : false}
                                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                                // placeholder="Email"
                                                                value={formData.email}
                                                                onChange={handleChange}
                                                            />
                                                            <label>Email</label>
                                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Dropdown */}
                                                <div className="form-group mt-3">
                                                    <div className="form-floating">
                                                        <select
                                                            name="messageType"
                                                            className={`form-select ${errors.messageType ? 'is-invalid' : ''}`}
                                                            value={formData.messageType}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Choose an option</option>
                                                            <option value="Diagnostic">Diagnostics</option>
                                                            <option value="Fellowship">Fellowship</option>
                                                            <option value="General">General</option>
                                                        </select>
                                                        <label>Message Type</label>
                                                        {errors.messageType && <div className="invalid-feedback">{errors.messageType}</div>}
                                                    </div>
                                                </div>

                                                {/* Textarea */}
                                                <div className="form-group mt-3">
                                                    <div className="form-floating">
                                                        <textarea
                                                            name="message"
                                                            className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                                            // placeholder="Leave a message here"
                                                            style={{ height: '100px', paddingTop: '25px' }}
                                                            value={formData.message}
                                                            onChange={handleChange}
                                                        />
                                                        <label>Message</label>
                                                        {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                                    </div>
                                                </div>

                                                {/* Button */}
                                                <div className="mt-3">
                                                    <a className="register-link" target="_blank">
                                                        <button className="btn-fill-icon" type="submit"><span className="material-symbols-outlined btn-icon-fill-style">keyboard_arrow_right</span>SUBMIT</button>
                                                    </a>
                                                </div>
                                                {/* <button className="btn-fill mt-3 mb-3" style={{ float: 'left' }} type="submit">
                                                    SUBMIT
                                                </button> */}


                                                {/* Success Message */}
                                                {/* {success && <div className="alert alert-success mt-3">Form submitted successfully!</div>} */}
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

            </div>


            <Footer />
        </>
    )
}

export default Contact;
